let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ebIlr")).then(() => parcelRequire('87jgf'));